module.exports = __webpack_public_path__ + "media/images/screen-all-posts-f3cb7b91de876ced56eacbbcab4f727b.jpg";